import styled from 'styled-components';

export const VPPGraphicImg = styled.img`
  height: 171.9px;
  width: 239px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    height: 269px;
    width: 374px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    height: 374px;
    width: 520px;
  }
`;

export default VPPGraphicImg;
